var React = require('react');

function AttrVers (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M14,26C7.4,26,2,20.6,2,14S7.4,2,14,2s12,5.4,12,12S20.6,26,14,26z M14,4C8.5,4,4,8.5,4,14s4.5,10,10,10s10-4.5,10-10\n\t\tS19.5,4,14,4z","key":0}),React.createElement("path",{"d":"M14.1,26c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5c2.5,0,4.5-2,4.5-4.5S16.6,4,14.1,4V2c3.6,0,6.5,2.9,6.5,6.5\n\t\tS17.7,15,14.1,15c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5V26z","key":1})])]);
}

AttrVers.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = AttrVers;

AttrVers.default = AttrVers;
